import React from 'react';
import { Zap, DollarSign, MousePointerClick, LayoutTemplate } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
export function Features() {
  const {
    t
  } = useLanguage();
  const {
    ref: titleRef,
    isVisible: titleVisible
  } = useScrollAnimation();
  const features = [{
    icon: Zap,
    title: t.whatIsAi.structure.title,
    desc: t.whatIsAi.structure.desc
  }, {
    icon: DollarSign,
    title: t.whatIsAi.content.title,
    desc: t.whatIsAi.content.desc
  }, {
    icon: MousePointerClick,
    title: t.whatIsAi.edit.title,
    desc: t.whatIsAi.edit.desc
  }, {
    icon: LayoutTemplate,
    title: t.whatIsAi.hosting.title,
    desc: t.whatIsAi.hosting.desc
  }];
  return <section id="why-ai" className="py-24 bg-[#050505]" data-id="element-139">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-140">
        <div ref={titleRef} className={`text-center mb-16 animate-hidden animate-fade-up ${titleVisible ? 'animate-visible' : ''}`} data-id="element-141">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-142">
            {t.whatIsAi.title}
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-143">
            {t.whatIsAi.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-144">
          {features.map((feature, index) => <FeatureCard key={index} feature={feature} index={index} data-id="element-145" />)}
        </div>
      </div>
    </section>;
}
function FeatureCard({
  feature,
  index
}: {
  feature: any;
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useScrollAnimation({
    threshold: 0.1
  });
  const delayClass = `delay-${index * 100}`;
  return <div ref={ref} className={`bg-[#0A0A0A] p-8 rounded-2xl border border-white/10 h-full animate-hidden animate-fade-up ${isVisible ? 'animate-visible' : ''} ${delayClass}`} data-id="element-146">
      <div className="flex items-center gap-4 mb-4" data-id="element-147">
        <div className="w-12 h-12 rounded-xl bg-accent-blue/10 flex items-center justify-center flex-shrink-0" data-id="element-148">
          <feature.icon className="w-6 h-6 text-accent-blue" data-id="element-149" />
        </div>
        <h3 className="text-xl font-bold text-white" data-id="element-150">{feature.title}</h3>
      </div>
      <p className="text-gray-400 leading-relaxed text-sm" data-id="element-151">{feature.desc}</p>
    </div>;
}